import { useMembership } from './useMembership';
import type { LoyaltyTier } from '@ui/avatar';

export interface TierIconProps {
  loyaltyTier: LoyaltyTier;
  showLoyaltyIcon: boolean;
  currentPoints: number;
  nextLevelPoints: number;
}

/**
 * Custom hook for dynamic tier icon functionality
 * Provides tier-based icon properties for Avatar components
 */
export const useTierIcon = (): TierIconProps => {
  const { membershipInfo, getPointsToNextTier } = useMembership();

  // Get the current tier name, return null if not available (no default to bronze)
  const loyaltyTier: LoyaltyTier =
    (membershipInfo?.currentTier?.name?.toLowerCase() as LoyaltyTier) || null;

  // Always show loyalty icon when membership info is available
  const showLoyaltyIcon = true;

  // Get current points balance
  const currentPoints = membershipInfo?.pointsBalance || 0;

  // Calculate next level points using the context function
  const nextLevelPoints = currentPoints + getPointsToNextTier();

  return {
    loyaltyTier,
    showLoyaltyIcon,
    currentPoints,
    nextLevelPoints,
  };
};
